(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eofy-bundle-modal-js"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /**
   * Fetch product data from /products/{handle}.js
   * Returns a Promise resolving to the product JSON.
   */
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.json();
      });
  }

  /**
   * Fetch the rendered quick-view HTML for a product.
   * The quick-view template has layout:false so returns only section HTML,
   * including server-rendered app blocks (Kaching Bundles, etc).
   */
  function fetchQuickViewHTML(handle, variantId) {
    var url = '/products/' + handle + '?view=quick-view';
    if (variantId) url += '&variant=' + variantId;
    return fetch(url)
      .then(function (res) {
        if (!res.ok) return null;
        return res.text();
      })
      .catch(function () {
        return null;
      });
  }

  /**
   * Extract the product content from the full quick-view HTML.
   * Looks for the main-product section, or falls back to the featured-product container.
   */
  function extractProductContent(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');

    // Try to find the main product section
    var section = doc.querySelector('[data-section-type="product"]');
    if (section) return section.innerHTML;

    // Fallback: find the featured-product div (quick-view mode in main-product)
    var featured = doc.querySelector('.featured-product');
    if (featured) return featured.innerHTML;

    // Last resort: grab body content
    var body = doc.body;
    if (body && body.children.length > 0) {
      var inner = '';
      for (var i = 0; i < body.children.length; i++) {
        inner += body.children[i].outerHTML;
      }
      return inner;
    }

    return null;
  }

  /**
   * Build the modal product HTML from JSON data (fallback when quick-view is unavailable).
   * This mirrors the quick-view structure: gallery + product-info.
   * Supports per-product title, price, and compare-at-price overrides.
   */
  function renderProductHTML(product, settings) {
    var override = settings.overrides && settings.overrides[product.handle];
    var hasOverride = override && (override.title || override.price > 0 || override.compareAtPrice > 0);

    var selectedVariant = product.variants[0];
    var media = product.media || [];
    var featuredImage = product.featured_image;
    var displayTitle = (hasOverride && override.title) || product.title;
    var displayPrice = (hasOverride && override.price > 0) ? override.price * 100 : selectedVariant.price;
    var displayCompare = (hasOverride && override.compareAtPrice > 0) ? override.compareAtPrice * 100 : selectedVariant.compare_at_price;
    var onSale = displayCompare > displayPrice;
    var available = selectedVariant.available;

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    // Build gallery images
    var mainImageHTML = '';
    var thumbnailsHTML = '';
    if (featuredImage) {
      mainImageHTML = '<div class="eofy-bundle-modal__product-main-image" data-main-image>' +
        '<img src="' + featuredImage + '" alt="' + escapeHtml(product.title) + '" />' +
        '</div>';
    }

    if (media && media.length > 1) {
      thumbnailsHTML = '<div class="eofy-bundle-modal__product-thumbnails">';
      for (var i = 0; i < media.length; i++) {
        var m = media[i];
        var isActive = i === 0 ? ' is-active' : '';
        thumbnailsHTML += '<button class="eofy-bundle-modal__product-thumb' + isActive + '" ' +
          'data-media-index="' + i + '" ' +
          'data-media-src="' + escapeHtml(m.src || '') + '" ' +
          'aria-label="View image ' + (i + 1) + '">' +
          '<img src="' + (m.src || featuredImage) + '" alt="' + escapeHtml(product.title) + '" />' +
          '</button>';
      }
      thumbnailsHTML += '</div>';
    }

    // Build variant options
    var optionsHTML = '';
    if (product.options && product.options.length > 0) {
      optionsHTML = '<div class="eofy-bundle-modal__options">';

      for (var oi = 0; oi < product.options.length; oi++) {
        var opt = product.options[oi];
        var optionName = escapeHtml(opt.name);
        var selectedVal = escapeHtml(opt.selected_value || opt.values[0]);
        var isColor = isColorOption(opt.name);

        optionsHTML += '<div class="eofy-bundle-modal__option" data-option-position="' + (oi + 1) + '">';
        optionsHTML += '<label class="eofy-bundle-modal__option-label">' + optionName + ': <span>' + selectedVal + '</span></label>';
        optionsHTML += '<div class="eofy-bundle-modal__swatch-list">';

        for (var vi = 0; vi < opt.values.length; vi++) {
          var val = opt.values[vi];
          var valStr = escapeHtml(val);
          var inputId = 'bundle-opt-' + product.id + '-' + oi + '-' + vi;
          var checked = val === opt.selected_value ? ' checked' : '';

          optionsHTML += '<input type="radio" class="eofy-bundle-modal__swatch-input" ' +
            'name="option-' + product.id + '-' + (oi + 1) + '" ' +
            'id="' + inputId + '" ' +
            'value="' + valStr + '" ' +
            'data-option-position="' + (oi + 1) + '"' +
            checked + ' />';

          var swatchClass = 'eofy-bundle-modal__swatch';
          if (isColor) swatchClass += ' eofy-bundle-modal__swatch--color';

          optionsHTML += '<label class="' + swatchClass + '" for="' + inputId + '" ' +
            'style="' + getColorStyle(val, isColor) + '"' +
            '>' + (isColor ? '' : valStr) + '</label>';
        }

        optionsHTML += '</div></div>';
      }

      optionsHTML += '</div>';
    }

    // Inventory status
    var inventoryHTML = '';
    if (available) {
      inventoryHTML = '<div class="eofy-bundle-modal__product-inventory eofy-bundle-modal__product-inventory--in-stock">' +
        '<span style="display:inline-block;width:8px;height:8px;background:#4da747;border-radius:50%;margin-right:6px;"></span>' +
        'In Stock</div>';
    } else {
      inventoryHTML = '<div class="eofy-bundle-modal__product-inventory eofy-bundle-modal__product-inventory--sold-out">' +
        '<span style="display:inline-block;width:8px;height:8px;background:#8a9297;border-radius:50%;margin-right:6px;"></span>' +
        'Sold Out</div>';
    }

    // Vendor link
    var vendorHTML = '';
    if (product.vendor) {
      vendorHTML = '<div class="eofy-bundle-modal__product-vendor">' +
        '<a href="/collections/all?q=' + encodeURIComponent(product.vendor) + '">' + escapeHtml(product.vendor) + '</a>' +
        '</div>';
    }

    // Full HTML
    var html = '<div class="eofy-bundle-modal__product" data-product-id="' + product.id + '">';

    // Gallery
    html += '<div class="eofy-bundle-modal__product-gallery">';
    html += mainImageHTML;
    html += thumbnailsHTML;
    html += '</div>';

    // Product info
    html += '<div class="eofy-bundle-modal__product-info">';
    html += '<h3 class="eofy-bundle-modal__product-title">' +
      '<a href="' + product.url + '" target="_blank" rel="noopener">' + escapeHtml(displayTitle) + '</a>' +
      '</h3>';
    html += vendorHTML;

    // Sale badge
    if (onSale) {
      var saving = displayCompare - displayPrice;
      html += '<div class="eofy-bundle-modal__product-sale-badge">Save ' + formatMoney(saving) + '</div>';
    }

    // Price
    html += '<div class="eofy-bundle-modal__product-price" data-price>';
    html += formatMoney(displayPrice);
    if (onSale) {
      html += '<span class="eofy-bundle-modal__product-price--compare">' + formatMoney(displayCompare) + '</span>';
    }
    html += '</div>';

    // Inventory
    html += inventoryHTML;

    // Variant options
    html += optionsHTML;

    // Quantity
    html += '<div class="eofy-bundle-modal__quantity">';
    html += '<button type="button" class="eofy-bundle-modal__quantity-btn" data-action="decrease-qty" aria-label="Decrease quantity">−</button>';
    html += '<input type="number" class="eofy-bundle-modal__quantity-input" name="quantity" value="1" min="1" aria-label="Quantity" />';
    html += '<button type="button" class="eofy-bundle-modal__quantity-btn" data-action="increase-qty" aria-label="Increase quantity">+</button>';
    html += '</div>';

    // Add to cart button
    html += '<button type="button" class="eofy-bundle-modal__add-to-cart" ' +
      'data-action="add-to-cart" ' +
      'data-variant-id="' + selectedVariant.id + '"' +
      (available ? '' : ' disabled') + '>' +
      (available ? 'Add to Cart' : 'Sold Out') +
      '</button>';

    html += '</div>'; // .product-info
    html += '</div>'; // .product

    return html;
  }

  /**
   * Check if an option name suggests it's a colour option.
   */
  function isColorOption(name) {
    var colorLabels = ['color', 'colour', 'couleur', 'farbe', '색', '色', 'カラー'];
    var lower = name.toLowerCase();
    for (var i = 0; i < colorLabels.length; i++) {
      if (lower.indexOf(colorLabels[i]) !== -1) return true;
    }
    return false;
  }

  /**
   * Generate inline style for a color swatch.
   */
  function getColorStyle(value, isColor) {
    if (!isColor) return '';
    var colorMap = {
      'black': '#000000', 'white': '#ffffff', 'navy': '#1e2d7d', 'red': '#cc0000',
      'blue': '#0066cc', 'green': '#008800', 'grey': '#808080', 'gray': '#808080',
      'orange': '#ff6700', 'yellow': '#ffcc00', 'brown': '#8b4513', 'tan': '#d2b48c',
      'hi-vis yellow': '#ccff00', 'hi-vis orange': '#ff6600'
    };
    var lower = value.toLowerCase();
    var color = colorMap[lower] || lower;
    return 'background-color:' + color + ';';
  }

  /**
   * Escape HTML entities.
   */
  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /**
   * Resolve the variant ID based on current option selections.
   */
  function resolveVariant(product, container) {
    var selectedOptions = {};
    var radios = container.querySelectorAll('.eofy-bundle-modal__swatch-input:checked');
    for (var i = 0; i < radios.length; i++) {
      var pos = radios[i].getAttribute('data-option-position');
      selectedOptions[pos] = radios[i].value;
    }

    for (var j = 0; j < product.variants.length; j++) {
      var v = product.variants[j];
      var match = true;
      var option1 = selectedOptions['1'];
      var option2 = selectedOptions['2'];
      var option3 = selectedOptions['3'];
      if (option1 && v.option1 !== option1) match = false;
      if (option2 && v.option2 !== option2) match = false;
      if (option3 && v.option3 !== option3) match = false;
      if (match) return v;
    }
    return product.variants[0];
  }

  /**
   * Update the modal UI after variant change (JSON-rendered mode).
   */
  function updateModalUI(product, variant, container) {
    // Update price
    var priceEl = container.querySelector('[data-price]');
    if (priceEl) {
      var onSale = variant.compare_at_price > variant.price;
      var priceHTML = formatMoneyStatic(variant.price);
      if (onSale) {
        priceHTML += '<span class="eofy-bundle-modal__product-price--compare">' + formatMoneyStatic(variant.compare_at_price) + '</span>';
      }
      priceEl.innerHTML = priceHTML;
    }

    // Update add-to-cart button
    var addToCartBtn = container.querySelector('[data-action="add-to-cart"]');
    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-variant-id', variant.id);
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out';
      }
    }

    // Update option label spans
    var checkedRadios = container.querySelectorAll('.eofy-bundle-modal__swatch-input:checked');
    for (var i = 0; i < checkedRadios.length; i++) {
      var pos = checkedRadios[i].getAttribute('data-option-position');
      var optionEl = container.querySelector('[data-option-position="' + pos + '"]');
      if (optionEl) {
        var labelSpan = optionEl.querySelector('.eofy-bundle-modal__option-label span');
        if (labelSpan) labelSpan.textContent = checkedRadios[i].value;
      }
    }

    // Disable unavailable variant swatches
    updateSwatchAvailability(product, container);
  }

  /**
   * Mark swatches as disabled if no variant exists with that option value.
   */
  function updateSwatchAvailability(product, container) {
    var selectedOptions = {};
    var checkedRadios = container.querySelectorAll('.eofy-bundle-modal__swatch-input:checked');
    for (var i = 0; i < checkedRadios.length; i++) {
      var pos = checkedRadios[i].getAttribute('data-option-position');
      selectedOptions[pos] = checkedRadios[i].value;
    }

    var optionPositions = {};
    var allRadios = container.querySelectorAll('.eofy-bundle-modal__swatch-input');
    for (var j = 0; j < allRadios.length; j++) {
      var pos = allRadios[j].getAttribute('data-option-position');
      if (!optionPositions[pos]) optionPositions[pos] = [];
      optionPositions[pos].push(allRadios[j]);
    }

    for (var posKey in optionPositions) {
      if (!optionPositions.hasOwnProperty(posKey)) continue;
      var radios = optionPositions[posKey];
      for (var r = 0; r < radios.length; r++) {
        var val = radios[r].value;
        var available = hasValidVariant(product, posKey, val, selectedOptions);
        radios[r].disabled = !available;
      }
    }
  }

  /**
   * Check if any variant exists with the given option value at position.
   */
  function hasValidVariant(product, targetPos, targetVal, otherSelected) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var optionKey = 'option' + targetPos;
      if (v[optionKey] !== targetVal) continue;

      var match = true;
      for (var pos in otherSelected) {
        if (!otherSelected.hasOwnProperty(pos) || pos === targetPos) continue;
        var otherKey = 'option' + pos;
        if (v[otherKey] !== otherSelected[pos]) {
          match = false;
          break;
        }
      }
      if (match) return true;
    }
    return false;
  }

  /**
   * Format money without Shopify dependency (fallback).
   */
  function formatMoneyStatic(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var fmt = Shopify.money_format || '${{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /**
   * Add item to cart via AJAX API.
   */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1
      })
    }).then(function (res) {
      return res.json();
    });
  }

  /**
   * Notify the mini-cart that a product was added so it re-renders
   * without requiring a page refresh. Dispatches on document.documentElement
   * to match the Warehouse theme's event delegation target.
   */
  function notifyCartAdded(variant, quantity) {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: variant,
        button: null,
        quantity: quantity || 1
      }
    }));
  }

  /**
   * Update the header cart count directly from the live cart,
   * as a fallback in case the theme's product:added listener
   * is not available (e.g. on the cart page or if theme JS failed to init).
   */
  function updateCartIconCount() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.header__cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
        }
        // Also update window.theme.cartCount so the MiniCart class
        // stays in sync if it re-initialises later.
        if (window.theme) window.theme.cartCount = cart.item_count;
      })
      .catch(function () { /* silently fail — the theme event may handle it */ });
  }

  /**
   * Open the mini-cart drawer if the theme supports it.
   * Mirrors the Warehouse theme's _openMiniCart behaviour.
   */
  function openCartDrawer() {
    if (typeof window.theme === 'undefined' || window.theme.cartType !== 'drawer') return;
    if (window.theme.pageType === 'cart') return;
    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
    if (!toggle) return;
    toggle.click();
  }

  /**
   * Re-initialize theme JS for the server-rendered quick-view content.
   * The Warehouse theme's theme.js handles variant switching. We trigger
   * it by dispatching change events on the variant selectors.
   */
  function initThemeVariantSwitching(container, product) {
    // Find variant selectors from the quick-view template
    var selectors = container.querySelectorAll('.product-form__single-selector');
    if (selectors.length === 0) return;

    // Attach change listeners to trigger variant updates
    for (var i = 0; i < selectors.length; i++) {
      selectors[i].addEventListener('change', function () {
        // The theme's product-form.js listens for changes on these elements
        // and updates the selected variant. We also dispatch a custom event
        // so the Kaching app block can react.
        document.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { productHandle: product.handle }
        }));
      });
    }
  }

  // ===== Init =====

  function initBundleModal() {
    var settingsEl = document.querySelector('[data-bundle-modal-settings]');
    if (!settingsEl) return;

    var settings;
    try {
      settings = JSON.parse(settingsEl.textContent);
    } catch (e) {
      return;
    }

    var overlayId = 'eofy-bundle-modal-overlay-' + settings.sectionId;
    var overlay = document.getElementById(overlayId);
    if (!overlay) return;

    var dialogBody = overlay.querySelector('[data-bundle-modal-body]');
    var currentProduct = null;
    var currentMode = 'json'; // 'server' or 'json' — which render mode is active
    var previousFocus = null;
    var isUpdating = false; // prevent recursive variant updates

    /**
     * Open the modal with a given product handle.
     * Tries server-rendered quick-view first (includes Kaching app blocks).
     */
    function openModal(handle) {
      previousFocus = document.activeElement;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Show loading
      dialogBody.innerHTML = '<div class="eofy-bundle-modal__loading">' +
        '<div class="eofy-bundle-modal__spinner"></div>' +
        '<span>Loading product details...</span>' +
        '</div>';

      // Fetch server-rendered quick-view HTML first (includes app blocks)
      fetchQuickViewHTML(handle).then(function (html) {
        if (html) {
          var content = extractProductContent(html);
          if (content) {
            // Wrap in our modal product container
            dialogBody.innerHTML = '<div class="eofy-bundle-modal__product eofy-bundle-modal__product--server-rendered">' +
              content +
              '</div>';
            currentMode = 'server';

            // Fetch product JSON too (for variant resolution)
            fetchProduct(handle).then(function (product) {
              currentProduct = product;
              initServerRenderedHandlers(dialogBody);
            }).catch(function () {
              // Just use the rendered HTML without variant switching
            });
            return;
          }
        }
        // Fall back to JSON-based render
        loadFallback(handle);
      }).catch(function () {
        loadFallback(handle);
      });
    }

    /**
     * Fall back to JSON-based rendering when quick-view template is unavailable.
     */
    function loadFallback(handle) {
      fetchProduct(handle).then(function (product) {
        currentProduct = product;
        currentMode = 'json';
        dialogBody.innerHTML = renderProductHTML(product, settings);
        attachJSONFormHandlers();
      }).catch(function () {
        dialogBody.innerHTML = '<div class="eofy-bundle-modal__loading">' +
          '<span>Unable to load product details.</span>' +
          '</div>';
      });
    }

    /**
     * Handle variant switching for server-rendered content.
     * Re-fetches the quick-view HTML with the new variant to update
     * all server-rendered elements including the Kaching app block.
     */
    function initServerRenderedHandlers(container) {
      var handle = currentProduct ? currentProduct.handle : null;
      if (!handle) return;

      // Find variant selectors from the rendered content
      var selectors = container.querySelectorAll('.product-form__single-selector');
      var qtyInput = container.querySelector('input[name="quantity"]');
      var addToCartBtn = container.querySelector('[data-action="add-to-cart"], .product-form__add-button, button[type="submit"]');

      // Attach variant change listeners
      for (var i = 0; i < selectors.length; i++) {
        (function (selector) {
          selector.addEventListener('change', function () {
            if (isUpdating) return;
            isUpdating = true;

            // Determine the selected variant from the selectors
            var selectedOptionValues = {};
            for (var j = 0; j < selectors.length; j++) {
              var pos = j + 1;
              selectedOptionValues[pos] = selectors[j].value;
            }

            // Find matching variant
            var variant = null;
            for (var k = 0; k < currentProduct.variants.length; k++) {
              var v = currentProduct.variants[k];
              if (v.option1 === selectedOptionValues['1'] &&
                  v.option2 === (selectedOptionValues['2'] || v.option2) &&
                  v.option3 === (selectedOptionValues['3'] || v.option3)) {
                variant = v;
                break;
              }
            }

            if (!variant) {
              isUpdating = false;
              return;
            }

            // Re-fetch the quick-view HTML with the new variant
            fetchQuickViewHTML(handle, variant.id).then(function (html) {
              if (html) {
                var content = extractProductContent(html);
                if (content) {
                  // Preserve quantity value
                  var qty = 1;
                  if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;

                  dialogBody.innerHTML = '<div class="eofy-bundle-modal__product eofy-bundle-modal__product--server-rendered">' +
                    content +
                    '</div>';

                  // Restore quantity
                  var newQtyInput = dialogBody.querySelector('input[name="quantity"]');
                  if (newQtyInput) newQtyInput.value = qty;

                  // Re-attach handlers
                  initServerRenderedHandlers(dialogBody);
                }
              }
              isUpdating = false;
            }).catch(function () {
              isUpdating = false;
            });
          });
        })(selectors[i]);
      }

      // Handle add to cart for server-rendered button
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function (e) {
          // Find the variant ID from the form
          var variantId = getSelectedVariantId(container);
          if (!variantId) return;

          var qty = 1;
          var newQtyInput = dialogBody.querySelector('input[name="quantity"]');
          if (newQtyInput) qty = parseInt(newQtyInput.value, 10) || 1;

          e.preventDefault();
          e.stopPropagation();

          this.classList.add('eofy-bundle-modal__add-to-cart--adding');

          var productHandle = currentProduct ? currentProduct.handle : handle;

          addToCart(variantId, qty).then(function (data) {
            var btn = dialogBody.querySelector('.eofy-bundle-modal__add-to-cart--adding');
            if (btn) btn.classList.remove('eofy-bundle-modal__add-to-cart--adding');
            if (data && !data.status) {
              notifyCartAdded({ id: variantId, handle: productHandle }, qty);
              updateCartIconCount().then(function () {
                openCartDrawer();
              });
              closeModal();
            }
          }).catch(function () {
            var btn = dialogBody.querySelector('.eofy-bundle-modal__add-to-cart--adding');
            if (btn) btn.classList.remove('eofy-bundle-modal__add-to-cart--adding');
          });
        });
      }

      // Quantity buttons (server-rendered may have them)
      var qtyDecBtn = dialogBody.querySelector('[data-action="decrease-picker-quantity"], .eofy-bundle-modal__quantity-btn[data-action="decrease-qty"]');
      var qtyIncBtn = dialogBody.querySelector('[data-action="increase-picker-quantity"], .eofy-bundle-modal__quantity-btn[data-action="increase-qty"]');
      var newQtyInput = dialogBody.querySelector('input[name="quantity"]');

      if (qtyDecBtn && newQtyInput) {
        qtyDecBtn.addEventListener('click', function () {
          var val = parseInt(newQtyInput.value, 10);
          if (val > 1) newQtyInput.value = val - 1;
        });
      }

      if (qtyIncBtn && newQtyInput) {
        qtyIncBtn.addEventListener('click', function () {
          var val = parseInt(newQtyInput.value, 10);
          newQtyInput.value = val + 1;
        });
      }
    }

    /**
     * Get the currently selected variant ID from the form.
     */
    function getSelectedVariantId(container) {
      // Check for hidden id input (no-js select)
      var idInput = container.querySelector('select[name="id"]');
      if (idInput && idInput.value) return idInput.value;

      // Check for hidden input with name="id"
      var hiddenId = container.querySelector('input[name="id"][type="hidden"]');
      if (hiddenId && hiddenId.value) return hiddenId.value;

      // Resolve from product data via option selectors
      if (currentProduct) {
        var selectors = container.querySelectorAll('.product-form__single-selector');
        var optionValues = {};
        for (var i = 0; i < selectors.length; i++) {
          optionValues[i + 1] = selectors[i].value;
        }

        for (var j = 0; j < currentProduct.variants.length; j++) {
          var v = currentProduct.variants[j];
          if (v.option1 === optionValues['1'] &&
              v.option2 === (optionValues['2'] || v.option2) &&
              v.option3 === (optionValues['3'] || v.option3)) {
            return v.id;
          }
        }
      }

      return null;
    }

    /**
     * Attach event handlers for JSON-rendered content.
     */
    function attachJSONFormHandlers() {
      if (!currentProduct) return;

      // Variant option changes
      var optionInputs = dialogBody.querySelectorAll('.eofy-bundle-modal__swatch-input');
      for (var i = 0; i < optionInputs.length; i++) {
        optionInputs[i].addEventListener('change', function () {
          if (!currentProduct || isUpdating) return;
          var variant = resolveVariant(currentProduct, dialogBody);
          updateModalUI(currentProduct, variant, dialogBody);
        });
      }

      // Thumbnail clicks
      var thumbs = dialogBody.querySelectorAll('.eofy-bundle-modal__product-thumb');
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].addEventListener('click', function () {
          var src = this.getAttribute('data-media-src');
          var mainImg = dialogBody.querySelector('.eofy-bundle-modal__product-main-image img');
          if (mainImg && src) {
            mainImg.src = src;
          }
          for (var j = 0; j < thumbs.length; j++) {
            thumbs[j].classList.remove('is-active');
          }
          this.classList.add('is-active');
        });
      }

      // Quantity buttons
      var qtyInput = dialogBody.querySelector('.eofy-bundle-modal__quantity-input');
      var qtyDecBtn = dialogBody.querySelector('[data-action="decrease-qty"]');
      var qtyIncBtn = dialogBody.querySelector('[data-action="increase-qty"]');

      if (qtyDecBtn && qtyInput) {
        qtyDecBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10);
          if (val > 1) qtyInput.value = val - 1;
        });
      }

      if (qtyIncBtn && qtyInput) {
        qtyIncBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10);
          qtyInput.value = val + 1;
        });
      }

      // Add to cart
      var addToCartBtn = dialogBody.querySelector('[data-action="add-to-cart"]');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          if (this.disabled) return;
          var variantId = this.getAttribute('data-variant-id');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

          this.classList.add('eofy-bundle-modal__add-to-cart--adding');

          addToCart(variantId, qty).then(function (data) {
            this.classList.remove('eofy-bundle-modal__add-to-cart--adding');
            if (data && !data.status) {
              notifyCartAdded({ id: variantId, handle: handle }, qty);
              updateCartIconCount().then(function () {
                openCartDrawer();
              });
              closeModal();
            }
          }.bind(this)).catch(function () {
            this.classList.remove('eofy-bundle-modal__add-to-cart--adding');
          }.bind(this));
        });
      }
    }

    /**
     * Close the modal.
     */
    function closeModal() {
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      currentProduct = null;
      currentMode = 'json';
      if (previousFocus) previousFocus.focus();
    }

    // ===== Event Listeners =====

    // Open modal triggers
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-action="open-bundle-modal"]');
      if (trigger) {
        e.preventDefault();
        var handle = trigger.getAttribute('data-product-handle');
        if (handle) openModal(handle);
      }
    });

    // Close modal
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="close-bundle-modal"]')) {
        closeModal();
        return;
      }
      // Close when clicking overlay background
      if (e.target === overlay) {
        closeModal();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    // Trap focus inside modal
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = overlay.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleModal);
  } else {
    initBundleModal();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eofy-hero-js"] && !Shopify.designMode) return;
  try {
    (function() {
  class EofyCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
    }

    connectedCallback() {
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.endDate - now;

      if (distance < 0) {
        clearInterval(this.interval);
        this.daysEl.textContent = '00';
        this.hoursEl.textContent = '00';
        this.minutesEl.textContent = '00';
        this.secondsEl.textContent = '00';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.daysEl.textContent = String(days).padStart(2, '0');
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('eofy-countdown-timer', EofyCountdownTimer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart-js"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var SELECTORS = {
    root: '.measurement-guide',
    tableWrapper: '.table-wrapper',
    chartTitle: 'th[class$="chart__title"]',
    scrollTrigger: '[data-scroll-target]',
    accordion: '.chart-accordion'
  };

  var SCROLL_RECHECK_MS = 450;
  var UNIT_KEY = 'dnc-fit-unit';
  // Room above a highlighted row so the chart title and column headings stay in view.
  var ROW_SCROLL_MARGIN = 120;

  function formatInches(cm) {
    var quarters = Math.round((cm / 2.54) * 4);
    var whole = Math.floor(quarters / 4);
    var fraction = ['', '\u00bc', '\u00bd', '\u00be'][quarters % 4];
    return (whole > 0 || !fraction ? String(whole) : '') + fraction;
  }
  var ACCORDION_TRANSITION = 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)';

  function SizeChart(root) {
    this.root = root;
    this.accordions = [];
  }

  SizeChart.prototype.getBrandId = function (element) {
    var current = element;

    while (current && current !== this.root) {
      var sibling = current.previousElementSibling;

      while (sibling) {
        if (sibling.id) return sibling.id;
        sibling = sibling.previousElementSibling;
      }

      current = current.parentElement;
    }

    return null;
  };

  SizeChart.prototype.measureContentHeight = function (content) {
    content.style.maxHeight = 'none';
    var height = content.scrollHeight;
    content.style.removeProperty('max-height');
    return height;
  };

  SizeChart.prototype.setOpen = function (accordion, isOpen) {
    var icon = accordion.header.querySelector('.chart-accordion__icon');

    accordion.header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    accordion.element.classList.toggle('chart-accordion--open', isOpen);

    if (isOpen) {
      accordion.content.style.maxHeight = this.measureContentHeight(accordion.content) + 'px';
      icon.textContent = '\u2212';
      return;
    }

    accordion.content.style.maxHeight = '0';
    icon.textContent = '+';
  };

  SizeChart.prototype.close = function (accordion) {
    if (accordion.element.classList.contains('chart-accordion--open')) {
      this.setOpen(accordion, false);
    }
  };

  SizeChart.prototype.open = function (accordion) {
    this.setOpen(accordion, true);
  };

  SizeChart.prototype.toggle = function (accordion) {
    if (accordion.element.classList.contains('chart-accordion--open')) {
      this.setOpen(accordion, false);
      return;
    }

    var self = this;
    this.accordions.forEach(function (entry) {
      if (entry !== accordion) self.close(entry);
    });

    this.open(accordion);
  };

  SizeChart.prototype.findAccordionsForTarget = function (targetId) {
    var matches = this.accordions.filter(function (entry) {
      return entry.brandId === targetId;
    });

    if (matches.length) return matches;

    var self = this;
    this.root.querySelectorAll(SELECTORS.accordion + '[data-brand-id="' + targetId + '"]').forEach(function (element) {
      var entry = self.accordions.find(function (accordion) {
        return accordion.element === element;
      });
      if (entry) matches.push(entry);
    });

    if (matches.length) return matches;

    var anchor = document.getElementById(targetId);
    if (!anchor) return matches;

    var sibling = anchor.nextElementSibling;
    while (sibling) {
      if (sibling.classList && sibling.classList.contains('chart-accordion')) {
        var entry = this.accordions.find(function (accordion) {
          return accordion.element === sibling;
        });
        if (entry) matches.push(entry);
      } else if (sibling.id) {
        break;
      }
      sibling = sibling.nextElementSibling;
    }

    return matches;
  };

  SizeChart.prototype.getScrollOffset = function () {
    var offset = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80) + 24;
    // Clear the sticky cm / inches bar too, so jumped-to headings are not under it
    var units = document.querySelector('[data-size-chart-units]:not([hidden])');
    if (units) offset += units.offsetHeight;
    return offset;
  };

  SizeChart.prototype.scrollTo = function (element, extra) {
    if (!element) return;

    var offset = this.getScrollOffset() + (extra || 0);
    var top = element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  SizeChart.prototype.getScrollTarget = function (targetId, accordions) {
    var sectionHeader = document.getElementById(targetId);
    var scrollTarget = accordions[0].element;

    if (sectionHeader) {
      var style = window.getComputedStyle(sectionHeader);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        scrollTarget = sectionHeader;
      }
    }

    return scrollTarget;
  };

  // options.size / options.gender come from Find my fit: highlight that size's row.
  SizeChart.prototype.navigateTo = function (targetId, options) {
    var matches = this.findAccordionsForTarget(targetId);
    if (!matches.length) return;

    var self = this;
    this.accordions.forEach(function (entry) {
      self.close(entry);
    });

    matches.forEach(function (entry) {
      self.open(entry);
    });

    var row = options && options.size ? this.highlightSize(matches, options.size, options.gender) : null;
    if (!row) this.clearHighlight();
    var scrollTarget = row || this.getScrollTarget(targetId, matches);
    var extra = row ? ROW_SCROLL_MARGIN : 0;

    requestAnimationFrame(function () {
      self.scrollTo(scrollTarget, extra);
      setTimeout(function () {
        self.scrollTo(scrollTarget, extra);
      }, SCROLL_RECHECK_MS);
    });
  };

  SizeChart.prototype.clearHighlight = function () {
    this.root.querySelectorAll('.is-fit-match').forEach(function (row) {
      row.classList.remove('is-fit-match');
      row.removeAttribute('aria-current');
      var cell = row.cells[0];
      if (cell) cell.removeAttribute('data-fit-label');
    });
  };

  function normalizeSize(value) {
    return String(value || '').replace(/\s+/g, '').toUpperCase();
  }

  // Each brand has a MEN and a WOMEN table; the accordion header carries that word.
  function tableGender(entry) {
    var title = entry.header.textContent.toUpperCase();
    return /WOMEN|LADIES/.test(title) ? 'women' : /\bMEN\b|\bMENS\b/.test(title) ? 'men' : '';
  }

  SizeChart.prototype.highlightSize = function (entries, size, gender) {
    this.clearHighlight();
    var wanted = normalizeSize(size);
    if (!wanted) return null;

    var candidates = entries;
    if (gender) {
      var sameGender = entries.filter(function (entry) {
        return tableGender(entry) === gender;
      });
      if (sameGender.length) candidates = sameGender;
    }

    var found = null;
    candidates.forEach(function (entry) {
      if (found) return;
      entry.content.querySelectorAll('tbody tr').forEach(function (row) {
        if (found || !row.cells.length || row.cells[0].colSpan > 1) return;
        var label = normalizeSize(row.cells[0].getAttribute('data-cm') || row.cells[0].textContent);
        // A boot row such as "8-8.5" also matches a size of 8.5.
        if (label === wanted || label.split('-').indexOf(wanted) !== -1) found = row;
      });
    });

    if (found) {
      found.classList.add('is-fit-match');
      found.setAttribute('aria-current', 'true');
      found.cells[0].setAttribute('data-fit-label', this.root.getAttribute('data-fit-label') || '');
    }
    return found;
  };

  SizeChart.prototype.buildAccordion = function (wrapper, table, titleCell) {
    var brandId = this.getBrandId(wrapper);
    var accordion = document.createElement('div');
    accordion.className = 'chart-accordion';

    if (brandId) {
      accordion.setAttribute('data-brand-id', brandId);
    }

    var header = document.createElement('button');
    header.className = 'chart-accordion__header';
    header.type = 'button';
    header.setAttribute('aria-expanded', 'false');
    header.innerHTML =
      titleCell.textContent.trim() + ' <span class="chart-accordion__icon" aria-hidden="true">+</span>';

    var content = document.createElement('div');
    content.className = 'chart-accordion__content';
    content.style.maxHeight = '0';
    content.style.overflow = 'hidden';
    content.style.transition = ACCORDION_TRANSITION;

    content.appendChild(table);
    accordion.appendChild(header);
    accordion.appendChild(content);
    wrapper.parentNode.insertBefore(accordion, wrapper);
    wrapper.remove();

    var entry = {
      element: accordion,
      header: header,
      content: content,
      brandId: brandId
    };

    var self = this;
    header.addEventListener('click', function () {
      self.toggle(entry);
    });

    this.accordions.push(entry);
  };

  SizeChart.prototype.buildAccordions = function () {
    var self = this;

    this.root.querySelectorAll(SELECTORS.tableWrapper).forEach(function (wrapper) {
      var table = wrapper.querySelector(':scope > table');
      if (!table) return;

      var titleCell = table.querySelector(SELECTORS.chartTitle);
      if (!titleCell) return;

      self.buildAccordion(wrapper, table, titleCell);
    });
  };

  SizeChart.prototype.bindNavigation = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var button = event.target.closest(SELECTORS.scrollTrigger);
      if (!button || !self.root.contains(button)) return;

      var targetId = button.getAttribute('data-scroll-target');
      if (!targetId) return;

      event.preventDefault();
      self.navigateTo(targetId);
    });
  };

  // /pages/workwear-size-guide?fit_size=87R#mens-work-pants opens that chart
  // with the 87R row highlighted (links from Find my fit on product pages).
  SizeChart.prototype.openFromHash = function () {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return;
    try {
      hash = decodeURIComponent(hash);
    } catch (error) {
      return;
    }
    var params = new URLSearchParams(window.location.search);
    this.navigateTo(hash, { size: params.get('fit_size') || '', gender: params.get('fit_gender') || '' });
  };

  // cm / inches. Converts columns headed "(cm)" or "MM"; the original value is
  // kept in data-cm so switching back is exact.
  SizeChart.prototype.bindUnits = function () {
    var self = this;
    this.unitToggles = document.querySelectorAll('[data-size-chart-units]');
    if (!this.unitToggles.length) return;

    this.unitToggles.forEach(function (toggle) {
      toggle.hidden = false;
      toggle.addEventListener('click', function (event) {
        var button = event.target.closest('[data-unit]');
        if (!button) return;
        self.setUnit(button.getAttribute('data-unit'), true);
      });
    });

    document.addEventListener('dnc:fit-unit', function (event) {
      self.setUnit(event.detail && event.detail.unit, false);
    });

    this.bindStickyUnits();

    var stored = 'cm';
    try {
      stored = window.localStorage.getItem(UNIT_KEY) === 'in' ? 'in' : 'cm';
    } catch (error) {
      stored = 'cm';
    }
    if (stored === 'in') this.setUnit('in', false);
  };

  // The bar is position: sticky in CSS; this only flags when it is pinned so it
  // can pick up its floating pill style.
  SizeChart.prototype.bindStickyUnits = function () {
    var toggles = this.unitToggles;
    var ticking = false;

    function update() {
      ticking = false;
      toggles.forEach(function (toggle) {
        var pinnedAt = parseFloat(getComputedStyle(toggle).top) || 0;
        var stuck = toggle.getBoundingClientRect().top <= pinnedAt + 1 && window.scrollY > 0;
        toggle.classList.toggle('is-stuck', stuck);
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  };

  SizeChart.prototype.setUnit = function (unit, remember) {
    unit = unit === 'in' ? 'in' : 'cm';
    if (remember) {
      try {
        window.localStorage.setItem(UNIT_KEY, unit);
      } catch (error) {
        /* not remembered, still switches */
      }
    }

    this.unitToggles.forEach(function (toggle) {
      toggle.querySelectorAll('[data-unit]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-unit') === unit ? 'true' : 'false');
      });
    });

    this.root.querySelectorAll('table').forEach(function (table) {
      var headers = table.querySelectorAll('thead tr:last-child th');
      var columns = {};
      headers.forEach(function (th, index) {
        if (!th.hasAttribute('data-unit-label')) th.setAttribute('data-unit-label', th.textContent);
        var label = th.getAttribute('data-unit-label');
        var scale = /\(cm\)/i.test(label) ? 1 : /^\s*mm\s*$/i.test(label) ? 0.1 : 0;
        if (!scale) return;
        columns[index] = scale;
        th.textContent = unit === 'in'
          ? label.replace(/\(cm\)/i, '(in)').replace(/^\s*mm\s*$/i, 'Inches')
          : label;
      });
      if (!Object.keys(columns).length) return;

      table.querySelectorAll('tbody tr').forEach(function (row) {
        if (row.cells.length !== headers.length) return;
        Object.keys(columns).forEach(function (index) {
          var cell = row.cells[index];
          if (!cell) return;
          if (!cell.hasAttribute('data-cm')) cell.setAttribute('data-cm', cell.textContent.trim());
          var original = cell.getAttribute('data-cm');
          var value = parseFloat(original);
          if (unit === 'cm' || isNaN(value) || !/^\d+(\.\d+)?$/.test(original)) {
            cell.textContent = original;
            return;
          }
          cell.textContent = formatInches(value * columns[index]);
        });
      });
    });
  };

  SizeChart.prototype.init = function () {
    var self = this;
    this.buildAccordions();
    this.bindNavigation();
    this.bindUnits();
    this.openFromHash();

    window.addEventListener('hashchange', function () {
      self.openFromHash();
    });

    // Find my fit asks for a chart by id; works even when the nav buttons are hidden.
    document.addEventListener('dnc:size-chart-navigate', function (event) {
      if (event.detail && event.detail.id) self.navigateTo(event.detail.id, event.detail);
    });
  };

  function start() {
    var root = document.querySelector(SELECTORS.root);
    if (!root || root.hasAttribute('data-size-chart-ready')) return;
    root.setAttribute('data-size-chart-ready', '');
    new SizeChart(root).init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
